import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil/index';
import {
  beaconSelector,
  mtgSavePreReqTempSelector,
  residentNoSelector,
} from '../recoil/selector';
import { validateRegistBackNo } from '../helper/validator';
import useNav from '../hooks/useNav';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useCert from '../hooks/useCert';
import moment from 'moment';
import useCounterInTime from '../hooks/useCounterInTime';
import { MEDIA_CODE, PAGE_NM } from '../types/types';
import useBeacon from '../hooks/useBeacon';
import { useBaseParam } from '../hooks/useBaseParam';
import { mutatePreReq } from '../../infra/api/mtg/mutatePreReq';
import { mutateSavePreRequest } from '../../infra/api/mtg/mutateSavePreRequest';
import useToast from '../hooks/useToast';
import { isIOS } from 'react-device-detect';

// 주민등록번호 유효성검사 실패 : helper Text
// 본인인증 실패 : 이벤트없음
// 본인인증 확인 실패 : toast
// 본인인증 횟수 초과 : alert(popup)

export const VALID_LENGTH = 7;
export const VALID_TRY_COUNT = 6;

const useStep1 = () => {
  const location: any = useLocation();
  const { media } = useParams();
  const isMtg = location?.state?.ref_page === PAGE_NM.MTG_CONFIRM;
  const beaconData = useRecoilValue(beaconSelector);
  const { addToast } = useToast();
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: isMtg ? PAGE_NM.MTG_SSN : PAGE_NM.CONDITIONS_STEP1,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);
  const sendBeaconAlertErrorMsgCertPerson = (msgNm: string) => {
    beacon.sendAlertErrorMsgCertPerson({
      properties: { msgNm },
    });
  };
  const sendBeaconCertSellSucc = () => {
    beacon.sendCertCellSucc();
  };
  const sendBeaconCertCellFail = () => {
    beacon.sendCertCellFail();
  };
  const sendBeaconCertCellWait = () => {
    beacon.sendCertCellWait();
  };
  const [personal, setPersonal] = useRecoilState(Atom.personalInfo);
  const [, setResidentNo] = useRecoilState(residentNoSelector);
  const [openKeypad, setKeypad] = useState<boolean>(true);
  const [openAlert, setAlert] = useState(false);
  const [ssnWarning, setSSNWarning] = useState<boolean>(false);
  const [availableTime, setAvailableTime] = useState<any>(0);
  const [availableCount, setAvailableCount] = useState<number>(1);
  const [txSeqNo, setTxSeqNo] = useState<string>('');
  const { navigate } = useNav();
  const { reqCert, checkCertComp } = useCert(media, isMtg);
  const { count } = useCounterInTime(5000, 5);

  const isUseSMSCert = () => {
    // if (personal.tester) {
    //   return false;
    // }
    // return (media === "lgu" && isIOS);
    return false;
  };
  const isValidationResidentNo = () => {
    if (personal.residentNo && personal.residentNo.length === VALID_LENGTH) {
      // personal.residentNo 에서  key: 암호화된 값, value: 실제 번호이므로 실제 번호만 추출
      const residentNumbers = personal.residentNo.map(
        (item: any) => item.value,
      );

      if (VALID_LENGTH > 6) {
        const genderValue = residentNumbers[0];
        if (genderValue !== Number(personal.gender)) {
          return false;
        }
      }

      const str =
        personal.birthDt.substring(2) +
        (VALID_LENGTH > 6 ? '' : personal.gender) +
        residentNumbers.join('');
      return validateRegistBackNo(str);
    } else {
      return false;
    }
  };
  const isValidationClickCount = () => {
    setAvailableCount((prev: number) => {
      return prev + 1;
    });
    if (!availableTime) {
      setAvailableTime(moment());
      return true;
    } else {
      if (
        moment.duration(moment().diff(availableTime)).asSeconds() < 60 &&
        availableCount > VALID_TRY_COUNT - 1
      ) {
        setAlert(true);
        return false;
      } else {
        return true;
      }
    }
  };
  const inputNumber = (number: any) => {
    if (personal?.residentNo?.length < VALID_LENGTH) {
      setResidentNo((prev: any) => {
        return [...prev, number];
      });
    }
  };
  // todo pop?
  const deleteNumber = () => {
    if (personal?.residentNo?.length > 0) {
      setResidentNo((prev: any) => {
        const newArr = [...prev];
        return newArr.splice(0, newArr.length - 1);
      });
    }
  };
  const clearNumber = () => {
    setResidentNo([]);
  };

  const wrappedCheckCertComp = useBaseParam(checkCertComp, {
    txSeqNo,
    mediaCd: media ? MEDIA_CODE[media.toUpperCase()] : '',
  });

  const onClickConfirmForSMS = async () => {
    const result: any = await wrappedReqCert();
    if (result?.data?.result?.txSeqNo) {
      const txSeqNo = result?.data?.result?.txSeqNo;
      const residentNo = getResidentNoForAPI();
      let state = {};
      if (location?.state) {
        state = {
          ...location.state,
          txSeqNo,
          residentNo,
        };
      } else {
        state = {
          txSeqNo,
          residentNo,
        };
      }
      navigate('/conditions/1/confirm', { state });
      return;
    } else {
      clearNumber();
      setSSNWarning(true);
      sendBeaconAlertErrorMsgCertPerson('주민등록번호를 다시 확인해주세요');
    }
  };

  const checkUserCert = async () => {
    if (!isValidationResidentNo()) return;
    const { avaliable } = count();
    if (!avaliable) {
      setAlert(true);
      return;
    }

    if (isUseSMSCert()) {
      await onClickConfirmForSMS();
      return;
    }

    const res = await wrappedCheckCertComp();
    if (res?.data?.isSucceed === true) {
      sendBeaconCertSellSucc();
      checkReuseYn();
      if (location?.state?.ref_page === PAGE_NM.MTG_CONFIRM) {
        await saveInputInfo();
        navigate('/mtg/loading', { state: location?.state });
      } else {
        navigate('/conditions/3', { state: location?.state });
      }
    } else {
      if (res?.data?.result?.resultCode === 'B164') {
        addToast('본인인증 대기중이에요. 완료후 다시 시도해 주세요.');
        sendBeaconCertCellWait();
      } else {
        sendBeaconCertCellFail();
        clearNumber();
      }
    }
  };

  const getResidentNoForAPI = () => {
    if (VALID_LENGTH > 6) {
      return personal.residentNo.slice(1).map((item: any) => {
        return item.key;
      });
    } else {
      return personal.residentNo.map((item: any) => {
        return item.key;
      });
    }
  };

  const wrappedReqCert = useBaseParam(
    reqCert,
    isUseSMSCert()
      ? {
          regidentNo: getResidentNoForAPI(),
          certRequestTypeCd: isUseSMSCert() ? '02' : '01',
        }
      : {
          regidentNo: getResidentNoForAPI(),
        },
  );

  const certProcess = async () => {
    if (isValidationResidentNo()) {
      // 주민등록번호 유효성 검사
      setSSNWarning(false);
      // 본인인증 요청횟수 검사
      if (isValidationClickCount()) {
        // LGU+ iOS에서 오류가 있어서 SMS 인증으로 대체
        if (isUseSMSCert()) {
          setKeypad(false);
          return;
        }

        // 본인인증 요청횟수 검사
        const result: any = await wrappedReqCert();
        if (result?.data?.result?.txSeqNo) {
          setTxSeqNo(result?.data?.result?.txSeqNo);
        }
        setTxSeqNo(result?.data?.result?.txSeqNo);
        setKeypad(false);
      }
    } else {
      if (personal?.residentNo?.length === VALID_LENGTH) {
        clearNumber();
        setSSNWarning(true);
        sendBeaconAlertErrorMsgCertPerson('주민등록번호를 다시 확인해주세요');
      } else if (personal?.residentNo?.length > 0) {
        setSSNWarning(false);
      }
    }
  };

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'production' && !isUseSMSCert()) {
      certProcessDev();
    } else {
      certProcess();
    }
  }, [personal.residentNo]);
  const leaveStep1 = () => {
    clearNumber();
    setPersonal((prev: any) => {
      return {
        ...prev,
        residentNo: [],
      };
    });
  };
  useEffect(() => {
    return () => leaveStep1();
  }, []);

  const [mInfo] = useRecoilState(Atom.mortgageInfo);
  const applyPreReq = useBaseParam(mutatePreReq, {
    preRequestSeq: mInfo.preRequestSeq,
  });

  const mtgSavePreReqTemp = useRecoilValue(mtgSavePreReqTempSelector);

  const putInputInfo = useBaseParam(mutateSavePreRequest, {
    ...mtgSavePreReqTemp,

    hopefulAmt: mtgSavePreReqTemp.hopefulAmt
      ? mtgSavePreReqTemp.hopefulAmt * 10000
      : mtgSavePreReqTemp.hopefulAmt,
    previousAmt: mtgSavePreReqTemp.previousAmt
      ? mtgSavePreReqTemp.previousAmt * 10000
      : mtgSavePreReqTemp.previousAmt,
    tenantAmt: mtgSavePreReqTemp.tenantAmt
      ? mtgSavePreReqTemp.tenantAmt * 10000
      : mtgSavePreReqTemp.tenantAmt,
    salaryAmt: mtgSavePreReqTemp.salaryAmt
      ? mtgSavePreReqTemp.salaryAmt * 10000
      : mtgSavePreReqTemp.salaryAmt,
    houseAmt: mtgSavePreReqTemp.housePrice
      ? mtgSavePreReqTemp.housePrice * 10000
      : mtgSavePreReqTemp.housePrice,

    disposalPlanYn:
      mtgSavePreReqTemp.disposalPlanYn === ''
        ? null
        : mtgSavePreReqTemp.disposalPlanYn,
    previousYn:
      mtgSavePreReqTemp.previousYn === '' ? null : mtgSavePreReqTemp.previousYn,
    tenantYn:
      mtgSavePreReqTemp.tenantYn === '' ? null : mtgSavePreReqTemp.tenantYn,
    firstYn:
      mtgSavePreReqTemp.firstYn === '' ? null : mtgSavePreReqTemp.firstYn,
    openDt: mtgSavePreReqTemp.openDt === '' ? null : mtgSavePreReqTemp.openDt,
    houseType:
      mtgSavePreReqTemp.houseType === '40' ? '10' : mtgSavePreReqTemp.houseType,
  });

  const saveMtgPreReq = async () => {
    return await putInputInfo();
  };

  const saveInputInfo = async () => {
    const response = await saveMtgPreReq();
    if (response.data.isSucceed) {
      const result = await applyPreReq();
      return result.data.isSucceed;
    }
    return false;
  };

  const navigateStep3 = async () => {
    if (location?.state?.ref_page === PAGE_NM.MTG_CONFIRM) {
      await saveInputInfo();
      navigate('/mtg/loading', { state: location?.state, replace: true });
    } else {
      navigate('/conditions/3', { state: location?.state });
    }
  };
  const checkReuseYn = () => {
    if (personal?.reuseYn === 'N' || !personal?.reuseYn) {
      setPersonal((prev: any) => {
        return {
          ...prev,
          objectTyp: '',
          hopefulAmt: '',
          salaryAmt: '',
          jobTyp: {},
          joinDt: '',
          employeeTyp: {},
          businessTyp: {},
          houseTyp: '',
          compRegNo: '',
          compNm: '',
          healthPayerTyp: '01',
          carOwnerYn: '',
          carNo: '',
          monthlyYn: '',
          regDate: '',
          reuseYn: '',
        };
      });
    }
  };

  // dev
  const [devResidentNo, setDevResidentNo] = useState('');
  const wrappedReqCertDev = useBaseParam(reqCert, {
    regidentNo: getResidentNoForAPI(),
    regidentTestNo: devResidentNo,
    custNm: personal.custNm,
    ctn: personal.cellNo,
  });
  const isValidationResidentNoDev = () => {
    if (personal?.custNm === '곽근모') {
      return isValidationResidentNo();
    }
    return personal.residentNo.length === VALID_LENGTH;
  };
  const certProcessDev = async () => {
    if (isValidationResidentNoDev()) {
      // 주민등록번호 유효성 검사 간소화
      setSSNWarning(false);
      if (isValidationClickCount()) {
        // 본인인증 요청횟수 검사
        //todo useBaseParam
        const result: any = await wrappedReqCertDev();
        if (result?.txSeqNo) {
          setTxSeqNo(result?.txSeqNo);
        }
        setKeypad(false);
      }
    } else {
      if (personal?.residentNo?.length === VALID_LENGTH) {
        clearNumber();
        setSSNWarning(true);
        sendBeaconAlertErrorMsgCertPerson('주민등록번호를 다시 확인해주세요');
      } else if (personal?.residentNo?.length > 0) {
        setSSNWarning(false);
      }
    }
  };

  const wrappedCheckCertCompDev = useBaseParam(checkCertComp, {
    txSeqNo,
    mediaCd: media ? MEDIA_CODE[media.toUpperCase()] : '',
  });
  const checkUserCertDev = async () => {
    if (!isValidationResidentNoDev()) return;
    const { avaliable } = count();
    if (!avaliable) {
      setAlert(true);
      return;
    }
    const result = await wrappedCheckCertCompDev();
    if (result.isSucceed) {
      sendBeaconCertSellSucc();
      checkReuseYn();
      if (location?.state?.ref_page === PAGE_NM.MTG_CONFIRM) {
        await saveInputInfo();
        navigate('/mtg/loading', { state: { ref_page: PAGE_NM.MTG_SSN } });
      } else {
        navigate('/conditions/3', { state: location?.state });
      }
    } else {
      sendBeaconCertCellFail();
      clearNumber();
    }
  };

  return {
    media,
    devResidentNo,
    setDevResidentNo,
    personal,
    inputKeys: personal.residentNo?.map((item: any) => item.value) ?? [],
    isValidation: isValidationResidentNo(),
    isValidationDev: isValidationResidentNoDev(),
    ssnWarning,
    inputNumber,
    deleteNumber,
    openKeypad,
    checkUserCert,
    checkUserCertDev,
    navigateStep3,
    clearNumber,
    setKeypad,
    navigate,
    openAlert,
    setAlert,
    setPersonal,
    checkReuseYn,
  };
};

export default useStep1;
